import React, { useState } from 'react';
import apiClient from '../Services/ApiClient';

export interface PatientUpdateResult {
	isLoading: boolean;
	isSuccess: boolean;
	handleUpdate: (values: any) => void;
	error?: Error | string | undefined;
}

export const usePatientUpdate = (
	patientId: string,
	onSuccess?: () => void,
): PatientUpdateResult => {
	const [isSuccess, setIsSuccess] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [error, setError] = useState<Error | string | undefined>();

	const handleUpdate = (values: any) => {
		setIsLoading(true);

		apiClient
			.patch('/patients/' + patientId, values)
			.then(() => {
				setIsLoading(false);
				setIsSuccess(true);
				onSuccess && onSuccess();
			})
			.catch(e => setError(e));
	};

	return { isLoading, isSuccess, error, handleUpdate };
};
